import { InboxController } from './inbox.controller';
import template from './inbox.html';

export const inboxComponent = {
  name: 'inboxComponent',
  restrict: 'E',
  template,
  controller: InboxController,
  controllerAs: 'vm',
  bindings: {}
};
